import { makeStyles } from 'tss-react/mui';

import noCssLinkTag from '@/styles/noCssTag';

export default makeStyles()({
  link: {
    ...noCssLinkTag,
  },
});
